import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import moment from 'moment';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue';
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue';
import { File, RecordInfoModel, HarvestShippingItem, HarvestShipping, SelectAgriFieldAndPlanting, HarvestRecordData, HarvestRecordItem ,Machine,Worker} from '@/types/Component';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';

@Component({
    components: {
        Thumbnail,
        EditModal,
        SelectFromPlantings,
        SelectFromAgriFields,
        RecordInfo
    }
})

export default class HarvestRecord extends Vue {
    private date = moment(new Date()).format('YYYY-MM-DD')
    private measurementTimingId = ''
    private measurementTimings: HarvestShippingItem[] = []
    private plantingAndAgriField: SelectAgriFieldAndPlanting = {
        agriField: {
            id: '',
            name: '',
            plantedArea: 0
        },
        planting: {
            id: '',
            name: '',
        }
    }
    private weightUnits: HarvestShippingItem[] = []
    private qualityStandards: HarvestShippingItem[] = []
    private harvestRecordData: HarvestRecordData[] = [
        { 
            harvestRecordDataId:'',
            harvestRecordId:"1",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: null,
            weightUnitName: '',
            harvestLotNumber:'',
            qualityDisplayFlag:''
        }
    ]
    private machines :Machine[] =[]
    private workers :Worker[] =[]
    private deletedWorkers=[] 
    private lotNumber = ''
    private existLotNumber = false
    private images: File[] = []
    private selectedImages: File[] = []
    private deletedImages: File[] = []
    private memo = ''
    private modalBaseUrl = ''
    private showEditModal = false
    private showSelectFromPlantings = false
    private showSelectFromAgriFields = false
    private isCopy = false
    private apiBaseUrl = '/harvest_records'
    private recordInfo: RecordInfoModel | null = null
    private isEditable = true

    @Prop()
    private harvestRecordId!: string

    @Prop()
    private recordDate!: string

    private created() {
        if(this.recordDate) this.date = this.recordDate
        if(this.harvestRecordId) this.getHarvestRecord(this.harvestRecordId)
        if(this.$route.query.copy_from) {
            this.getHarvestRecord(String(this.$route.query.copy_from))
            this.isCopy = true
        }
        this.getMeasurementTiming()
        this.getQualityStandards()
        this.getWeightUnits()
    }

    private init() {
        this.date = moment(new Date()).format('YYYY-MM-DD')
        this.measurementTimingId = ''
        this.plantingAndAgriField = {
            agriField: {
                    id: '',
                    name: '',
                plantedArea: 0
                },
                planting: {
                    id: '',
                    name: '',
                }
            }
        this.harvestRecordData = [
                {
                     
                    harvestRecordDataId:"",
                    harvestRecordId:"1",
                    weightPerUnit:1,
                    qualityStandardId: '',
                    qualityStandardName: '',
                    quantity: null,
                    remainingQuantity:null,
                    weightUnitId: null,
                    weightUnitName: '',
                    harvestLotNumber:'',
                    qualityDisplayFlag:''
                }
            ]
            this.workers =[]
            this.deletedWorkers =[]
            this.machines =[]
        this.lotNumber = ''
        this.existLotNumber = false
        this.images = []
        this.selectedImages = []
        this.deletedImages = []
        this.memo = ''
        this.showEditModal = false
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.isCopy = false
        this.getMeasurementTiming()
        this.getQualityStandards()
        this.getWeightUnits()
    }

    private getHarvestRecord(id: string) {
        this.measurementTimingId = ''
        this.$apiClient.doRequest('get', '/harvest_records/' + id).then(ret => {
            const item = toCamel(ret) as HarvestRecordItem
            this.isEditable = item.isEditable
            const parent = this.$parent as any
            parent.isEditable = item.isEditable
            this.date = item.harvestDate
            this.plantingAndAgriField = {
                agriField: {
                    id: item.agriField?.id,
                    name: item.agriField?.name,
                    plantedArea: item.agriField?.plantedArea
                },
                planting: {
                    id: item.planting?.id,
                    name: item.planting?.name,
                }
            }
            this.measurementTimingId = item.measurementTimingId
            this.harvestRecordData = item.harvestRecordData
            this.lotNumber = item.lotNumber
            this.memo = item.memo
            this.recordInfo = {
                createdUser: item.createdUser,
                created: item.created,
                updatedUser: item.updatedUser,
                updated: item.updated
            }
            this.getMeasurementTiming()
            this.getQualityStandards()
            this.getWeightUnits()
            if(!this.isCopy && item.fileId.length > 0) {
                const promise: any = []
                item.fileId.forEach((id: string) => {
                    promise.push(this.$apiClient.doRequest('get', `/harvest_records/${this.harvestRecordId}/images/${id}`))
                })
                Promise.all(promise).then(ret => {
                    const file = toCamel(ret) as File[]
                    this.images = file
                })
            }
        })
    }

    private getMeasurementTiming() {
        this.$apiClient.doRequest('get', '/measurement_timings?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.measurementTimings = item.measurementTimings
        }).catch(() => {
            return
        })
    }

    private getQualityStandards() {
        this.$apiClient.doRequest('get', '/quality_standards?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.qualityStandards = item.qualityStandards
        }).catch(() => {
            return
        })
    }

    private getWeightUnits() {
        this.$apiClient.doRequest('get', '/weight_units?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.weightUnits = item.weightUnits
        }).catch(() => {
            return
        })
    }

    private updateItems(baseUrl: string) {
        switch (baseUrl) {
            case '/weight_units':
                this.getWeightUnits()
                break
            case '/measurement_timings':
                this.getMeasurementTiming()
                break
            case '/quality_standards':
                this.getQualityStandards()
                break
        }
    }

    private closeEditModal() {
        this.showEditModal = false
    }

    private commitPlantingAndField(item: SelectAgriFieldAndPlanting) {
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.plantingAndAgriField = {
            agriField: {
                id: item.agriField.id,
                name: item.agriField.name,
                plantedArea: item.agriField.plantedArea
            },
            planting: {
                id: item.planting?.id,
                name: item.planting?.name
            }
        }
    }

    private editMeasurementTiming() {
        this.modalBaseUrl = '/measurement_timings'
        this.showEditModal = true
    }

    private editWeightUnits() {
        this.modalBaseUrl = '/weight_units'
        this.showEditModal = true
    }

    private editQualityStandards() {
        this.modalBaseUrl = '/quality_standards'
        this.showEditModal = true
    }

    private addHarvestRecordData() {
        this.harvestRecordData.push({
            harvestRecordDataId:'',
            harvestRecordId:"1",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: null,
            weightUnitName: '',
            harvestLotNumber:'',
            qualityDisplayFlag:''
        })
    }

    private deleteHarvestRecordData(index: number) {
        this.harvestRecordData.splice(index, 1)
        this.inputChanged()
    }

    private deletePlantingAndAgriField() {
        this.plantingAndAgriField = {
            agriField: {
                id: '',
                name: '',
                plantedArea: 0
            },
            planting: {
                id: '',
                name: '',
            }
        }
        this.inputChanged()
    }

    // ロットナンバーの仕様見直しのためUIからコメントアウトされたためロジック側もコメントアウト
    // private checkLotNumber(e: any) {
    //     if(e.target.value){
    //         this.$apiClient.doRequest('get', '/harvest_records/lot_number/' + e.target.value).then(ret => {
    //             this.existLotNumber = true
    //         }).catch(error => {
    //             return
    //         })
    //     }
    // }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if(this.$apiClient.isSizeOver(files)) {
            return
        }

        for (const file of files) {
            if (this.$apiClient.isImageFile(file.name)) {
                this.$apiClient.getBase64(file).then((image: any) => {
                    const item = {
                        file: image.file,
                        url: image.base64
                    } as File
                    this.images.push(item)
                }).catch(() => {
                    window.alert('画像ファイルが読み込めませんでした')
                })
            } else {
                window.alert('画像ファイルを選択してください')
            }
        }
        e.target.value = ''
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if(image.id) {
            this.deletedImages.push(image)
        }
    }

    private validate() {
        const errmsg: string[] = []

        // 日付
        if(!this.date) {
            errmsg.push('日付を選択してください。')
        }

        // 計測タイミング
        if(!this.measurementTimingId) {
            errmsg.push('計測タイミングを選択してください。')
        }

        // 作付・圃場
        if(this.plantingAndAgriField.agriField.id == '' || this.plantingAndAgriField.planting.id == '') {
            errmsg.push('作付・圃場を選択してください。')
        }

        //収穫データ
        if(this.harvestRecordData.length == 0) {
            errmsg.push('収穫データを入力してください。')
        }else {
            let qualityStandardMessage = ''
            let quantityMessage = ''
            for(const item of this.harvestRecordData) {
                if(!item.qualityStandardId) {
                    qualityStandardMessage = '品質・規格を入力してください。'
                }
                if(item.quantity) {
                    const isMinus: boolean = /-/.test(item.quantity.toString())
                    const integer: string = item.quantity.toString().split('.')[0]
                    const decimal: string = item.quantity.toString().split('.')[1]
                    if(isMinus || integer.length > 7 || decimal && decimal.length > 2){
                        quantityMessage = '数量は0以上の整数部7桁小数部2桁までの数値を入力してください。'
                    }
                }else {
                    quantityMessage = '数量を入力してください。'
                }
            }
            if(qualityStandardMessage) errmsg.push(qualityStandardMessage)
            if(quantityMessage) errmsg.push(quantityMessage)
        }

        // メモ
        if(this.memo && this.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.memo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private saveRecord() {
        if(!this.validate()){
            return
        }
        const harvestRecordData = this.harvestRecordData.map(data => {
            return {
                quality_standard_id: data.qualityStandardId,
                quantity: data.quantity ? data.quantity : null,
                remaining_quantity : data.quantity ? data.quantity : null,
                weight_unit_id: (!data.weightUnitId || data.weightUnitId === 'null') ? null : data.weightUnitId
            }
        })
        const workers = [] as any
        const machines =[] as any
        const params = {
            harvest_date: this.date,
            measurement_timing_id: this.measurementTimingId,
            planting_id: this.plantingAndAgriField.planting.id,
            agri_field_id: this.plantingAndAgriField.agriField.id,
            harvest_record_data: harvestRecordData,
            work_date: this.date,
            kind :"ACTUAL",
            workers: workers,
            machines: machines,
            deletedWorkers:[],
            lot_number: this.lotNumber,
            memo: this.memo
        }
        const promise = []
        let message = '変更を保存しました。'
        if(this.harvestRecordId) {
            if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false
            }
            promise.push(this.$apiClient.doRequest("put", `${this.apiBaseUrl}/${this.harvestRecordId}`, params))
        }else {
            message = '保存しました。'
            promise.push(this.$apiClient.doRequest("post", this.apiBaseUrl, params))
        }
        Promise.all(promise).then((ret: any) => {
            const imageRequests: any = []
            const uploadImages = this.images.filter((file: File) => !file.id)
            uploadImages.forEach(image => {
                imageRequests.push(this.$apiClient.fileUpload(`${this.apiBaseUrl}/${ret[0].id}/images`, image.file))
            })
            this.deletedImages.forEach(image => {
                imageRequests.push(this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${ret[0].id}/images/${image.id}`))
            })
            Promise.all(imageRequests).then(ret => {
                this.$toasted.success(message)
                if(this.$route.query.return_to){
                    this.$router.push(`/${this.$route.query.return_to}?date=${this.date}`).then(() => {return})
                }else {
                    this.init()
                    if(this.harvestRecordId) {
                        this.getHarvestRecord(this.harvestRecordId)
                    }
                }
            })
        }).catch(() => {
            this.$toasted.error('保存に失敗しました。')
        })
    }

    private deleteRecord() {
        const confirm = window.confirm('削除しますか？')
        if(confirm && this.harvestRecordId) {
            this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${this.harvestRecordId}`).then(ret =>{
                this.$toasted.success('削除しました。')
                this.init()
                if(this.$route.query.return_to){
                    this.$router.push('/' + this.$route.query.return_to).then(() => {return})
                }
            }).catch(() => {
                this.$toasted.error('削除に失敗しました。')
            })
        }else if(confirm && !this.harvestRecordId) {
            this.$toasted.error('収穫記録が存在しません。')
        }else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    private filterWeightUnitsByDetail(item: HarvestRecordData) {
        return this.weightUnits
          .filter(wu => item.weightUnitId == wu.id || wu.isHidden === false)
    }

    get filterMeasurementTimings() {
        return this.measurementTimings
          .filter(m => this.measurementTimingId == m.id || m.isHidden === false)
    }

    private filterQualityStandardsByDetail(item: HarvestRecordData) {
        return this.qualityStandards
          .filter(qs => item.qualityStandardId == qs.id || qs.isHidden === false)
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    cancelRecord(): void {
        const result = window.confirm('変更内容を破棄します。よろしいですか。')
        if (result) {
          if (this.harvestRecordId !== undefined && this.harvestRecordId !== ''){
            this.init()
            this.getHarvestRecord(this.harvestRecordId);
          }else{
            this.init()
          }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
    }
}